// src/Views/CV.js
import React from 'react';
import ScrambleText from '../Components/ScrambleText';
import './CV.css';
import CVWeb from '../assets/files/CVWeb.pdf';

function CV() {
  return (
    <main className="cv-page">
      <section className="cv-hero">
        {/* <p className="cv-eyebrow"></p> */}
        <h1><ScrambleText text="Curriculum Vitae" /></h1>
        <p className="cv-intro">
          A quick overview of my work, research, activities, and experience.
        </p>
      </section>

      <a
        className="cv-mobile-open"
        href={CVWeb}
        target="_blank"
        rel="noopener noreferrer"
      >
        Open Full CV
      </a>

      <section className="cv-viewer-wrap">
        <iframe
          src={`${CVWeb}#view=Fit&toolbar=1`}
          title="Shashank Balaji CV"
          className="cv-viewer"
          scrolling="yes"
        />
      </section>

      <p className="cv-update-note">
        Last updated <time dateTime="2026-10-13">13 October 2026</time>
      </p>
    </main>
  );
}

export default CV;
